<template>
  <v-app>
    <v-toolbar color="warning" id="toolbar" class="py-2">
      <v-layout row wrap align-center>
        <!-- <img class="toolbar-title-img" src="logo.png" >       -->
        <!-- <v-toolbar-title class="primary--text headline">Eagleridge Online Enrollment </v-toolbar-title>   -->
        <!-- { 'app-xs': $vuetify.breakpoint.xs, 'health-conditions-md': $vuetify.breakpoint.md }  -->
        <h1 class="primary--text mt-5">Eagleridge Online Enrollment</h1>
        <v-spacer></v-spacer>
        <v-btn v-if="user.id" @click.stop="logout" color="primary" flat>Logout</v-btn>
      </v-layout>
    </v-toolbar>
    <div v-if="showNotifications" class="notifications">
      <v-alert
        :value="n.active"
        v-for="n in notifications"
        :key="n.id"
        :type="n.type"
      >{{ n.message }}</v-alert>
    </div>
    <v-content>
      <admin-dashboard v-if="user.role === 'admin'">
        <router-view></router-view>
      </admin-dashboard>

      <router-view v-else></router-view>

      <v-dialog v-model="invalidToken" width="580" persistent>
        <v-card class="elevation-10">
          <v-toolbar dark color="error">
            <v-toolbar-title>Session Expired</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <h3
              class="py-5 px-2"
            >Your session has expired, please logout and log back in to continue.</h3>
            <h5 class="px-2">* sessions are good for 1 hour *</h5>
          </v-card-text>
          <v-card-actions class="mx-3 pb-3">
            <v-spacer></v-spacer>
            <v-btn class="red lighten-1 white--text" @click.stop="logout">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-content>
    <v-footer height="auto" color="warning">
      <v-layout justify-center>
        <v-flex text-xs-center primary--text xs12 subheading pa-3>
          &copy;2018 - Present
          <strong>Eagleridge</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import AdminDashboard from "./components/Admin/AdminDashboard";

export default {
  components: {
    AdminDashboard: AdminDashboard
  },
  data() {
    return {
      matchingRoute: false
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    jwt() {
      return this.$store.state.auth.token;
    },
    invalidToken() {
      return this.$store.state.errorModule.invalidToken;
    },
    notifications() {
      return this.$store.state.admin.systemNotifications;
    },
    showNotifications() {
      let sn = this.$store.state.admin.systemNotifications;
      let active = false;

      sn.forEach(message => {
        if (message.active) {
          active = true;
        }
      });

      return active && this.matchingRoute;
    }
  },
  watch: {
    $route(to, from) {
      switch (to.name) {
        case "Login":
        case "Register":
        case "ResetForm":
          this.matchingRoute = true;
          break;
        default:
          this.matchingRoute = false;
          break;
      }
    }
  },
  created() {
    this.$store.dispatch("getSystemNotifications");
    switch (this.$router.currentRoute.name) {
      case "Login":
      case "Register":
      case "ResetForm":
        this.matchingRoute = true;
        break;
      default:
        this.matchingRoute = false;
        break;
    }
    // set authorization token if available
    if (this.jwt) {
      this.$store.dispatch("setAxiosAuthHeader", this.jwt);
    }
  },
  methods: {
    logout() {
      sessionStorage.clear();
      window.location.reload();
    }
  }
};
</script>

<style>
/* img.toolbar-title-img {
    height: 49px;
    width: 60px;
  } */
/* h1 {
    font-size: 12px;
  } */

@media screen and (min-width: 320px) {
  #toolbar {
    height: 110px;
    display: center;
  }

  #toolbar2 {
    height: 76px;
  }

  .toolbar-title {
    display: center;
    font-size: 25px;
  }

  h1 {
    text-align: center;
    font-size: 35px;
  }

  h2 {
    text-align: left;
    font-size: 20px;
  }

  .large {
    margin: 0px auto 25px auto;
    font-size: 18px;
  }

  #login {
    display: inline;
    margin: 15px 50px 5px auto;
  }

  a {
    display: inline;
    margin: auto 0px 5px 40px;
  }

}

@media screen and (min-width: 374px) {
  #toolbar {
    height: 110px;
  }

  #toolbar2 {
    height: 76px;
  }

  .toolbar-title {
    display: center;
    font-size: 20px;
  }

  img.toolbar-title-img {
    display: block;
    padding: px;
    margin: 150px auto 5px auto;
    width: 25%;
    height: 25%;
  }

  h1 {
    text-align: center;
    font-size: 35px;
  }

  h2 {
    text-align: center;
    font-size: 35px;
    margin-bottom: 20px;
  }
  .large {
    margin: 0px auto 25px auto;
    font-size: 20px;
  }
  #login {
    display: inline;
    margin: 15px 80px 5px auto;
  }
  a {
    display: inline;
    margin: auto 0px 5px 65px;
  }
}

@media screen and (min-width: 413px) {
  #toolbar {
    height: 115px;
  }

  #toolbar2 {
    height: 76px;
  }

  h1 {
    display: center;
    font-size: 45px;
    margin: -10px auto 0px auto;
    margin-left: 25px;
  }

  h2 {
    text-align: center;
    font-size: 35px;
  }

  img.toolbar-title-img {
    display: center;
    margin: 150px auto 0px auto;
    width: 20%;
    height: 12%;
  }

  .toolbar-title {
    display: center;
    font-size: 35px;
  }

   #login {
    margin: 15px 100px 5px 5px;
  }

  a {
    margin: 0px 0px 5px 88px;
  }
}

@media screen and (min-width: 765px) {
  #toolbar {
    height: 110px;
  }

  #toolbar2 {
    height: 54px;
  }

  h1 {
    display: center;
    font-size: 45px;
    margin: 160px 30px 0px 45px;
  }

  h2 {
    text-align: center;
    font-size: 25px;
  }

  img.toolbar-title-img {
    /* display: block; */
    margin: 160px auto 0px auto;
    width: 15%;
    height: 12%;
  }

  .toolbar-title {
    display: center;
    font-size: 30px;
  }
   .large {
    margin: 0px auto 25px auto;
    font-size: 18px;
  }
  #login {
    display: inline;
    margin: 5px 0px 0px 50px;
  }

  a {
    display: inline;
    margin: 0px 0px 0px 50px;
  }
}

@media screen and (min-width: 1024px) {
  #toolbar {
    height: 125px;
  }

  #toolbar2 {
    height: 76px;
  }

  #headline {
    margin: 0px 0px 0px 0px;
  }

  h1 {
    display: center;
    font-size: 60px;
    margin: 25px 30px 0px 75px;
  }

  h2 {
    text-align: center;
    font-size: 35px;
    margin-bottom: 10px;
  }

  img.toolbar-title-img {
    display: block;
    margin: 125px auto 15px auto;
    width: 8%;
    height: 5%;
  }

  /* p i {
        text-align: left;
    } */

  li {
    margin-left: 10px;
    font-size: 18px;
  }

  /* .toolbar-title {
        display: center;
        font-size: 50px;
      } */
}

/* @media screen and (min-width: 1904px) {
    .notifications > * {
      font-size: 2rem;
    }
  }  */

/* .app-xs {
    height: 200px;
    font-size: 4em !important;
    font-weight: 400;
    line-height: 32px !important;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;

  } */

/* .app-md {
    font-size: 20px !important;
    font-weight: 400;
    line-height: 32px !important;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
} */

/* .app-lg {
    font-size: 24px !important;
    font-weight: 400;
    line-height: 32px !important;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
} */
</style>
